import React from "react";

export default function StripeLoader() {
  return (
    <div className="stripe__loader__container">
      <div className="stripe__loader"></div>
    </div>
  );
}
